import { createContext, useContext } from "react";
import { useGetHeaderLogoQuery } from "@/services/Redux/Features/HeaderLogo/HeaderLogoSlice";

interface LogoContextType {
    revenueLogo?: string;
    emblemLogo?: string;
    isLoading: boolean;
}

const LogoContext = createContext<LogoContextType>({
    isLoading: true,
});

export const LogoProvider = ({ children }: { children: React.ReactNode }) => {
    const { data, isLoading, isSuccess } = useGetHeaderLogoQuery();

    const value: LogoContextType = {
        revenueLogo: isSuccess ? data?.items?.[1]?.imageUrl : undefined,
        emblemLogo: isSuccess ? data?.items?.[0]?.imageUrl : undefined,
        isLoading,
    };

    return (
        <LogoContext.Provider value={value}>
            {children}
        </LogoContext.Provider>
    );
};

export const useLogo = () => useContext(LogoContext);
